import { render, staticRenderFns } from "./QA-List.vue?vue&type=template&id=ea188b64&scoped=true"
import script from "./QA-List.vue?vue&type=script&lang=js"
export * from "./QA-List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea188b64",
  null
  
)

export default component.exports